import React from "react";
import { useFlags } from "launchdarkly-react-client-sdk";
import { Box, ButtonWithAction } from "@thecb/components";
import { isReceiptEligible } from "@/util/receipt";

const DownloadReceiptButton = ({ status, isLoading, onDownload }) => {
  const flags = useFlags();
  const receiptDownloadEnabled = flags?.["revm-receipt-download"];

  if (!receiptDownloadEnabled || !isReceiptEligible(status)) {
    return null;
  }

  return (
    <Box padding="0">
      <ButtonWithAction
        variant="smallSecondary"
        text="Download Receipt"
        isLoading={isLoading}
        action={onDownload}
        extraStyles={`flex-grow: 1; flex-basis: 7.5rem; padding: 0.75rem 1.5rem; border-radius: 4px;`}
        dataQa="Download Receipt"
      />
    </Box>
  );
};

export default DownloadReceiptButton;
